import { Container, Section } from '@resolute/ui';
import { CheckCircle2 } from 'lucide-react';


import { Reveal, StaggerGroup, StaggerItem } from '@/components/motion/reveal';

const BENEFITS = [
  'Health insurance for you and your family',
  'Performance-linked incentives, on top of base salary',
  'Learning & development budget for courses and certifications',
  'Clear, fast-tracked growth paths as the company scales',
  'Paid time off, plus company-wide festive holidays',
  'A team that will actually teach you the business, not just the job',
];

export function CareersBenefits() {
  return (
    <Section spacing="md" className="border-t border-border bg-muted/30">
      <Container>
        <Reveal className="max-w-2xl">
          <p className="text-sm font-medium uppercase tracking-widest text-secondary">
            What you&apos;ll get
          </p>
          <h2 className="mt-2 text-balance font-display text-display-sm font-semibold tracking-tight">
            Benefits that back a demanding job.
          </h2>
        </Reveal>

        <StaggerGroup as="ul" className="mt-10 grid grid-cols-1 gap-x-8 gap-y-4 sm:mt-12 sm:grid-cols-2">
          {BENEFITS.map((benefit) => (
            <StaggerItem key={benefit} as="li" className="flex items-start gap-3">
              <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-success" aria-hidden="true" />
              <span className="text-foreground">{benefit}</span>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </Container>
    </Section>
  );
}
